import React, { useState, useContext, useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ReactDOM from 'react-dom'
import ModalWindow from '../../layout/modalwindow/ModalWindow'
import StockInFooterStyle from './css/StockInFooterStyle'
import { ContentFooter } from '../../layout/Content'
import StockInListController from '../stockinlist/StockInListController'
import StockInItemController from '../stockinitem/StockInItemController'
import { stockInControllerContext } from './StockInController'
import { appContext } from '../../../App'
import { getStockInByID } from '../StockInFunctions'
import { longDateAndTimeString } from '../../utilities/utilities'

function StockInFooter() {
  const app = useContext(appContext)
  const setContent = app.content[1]
  const stockInController = useContext(stockInControllerContext)
  const stockIn = stockInController.stockIn[0]
  const { saveStockIn } = stockInController
  const [newRecordCount, setNewRecordCount] = useState(0)
  const [successMessage, setSuccessMessage] = useState(false)
  const [postOK, setPostOK] = useState(null)

  const showMessageBoxSINotFound = () => {
    const onClick = () => {
      ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
      setContent(<StockInListController />)
    }

    ReactDOM.render (
      <ModalWindow
        id='mw-parent'
        width='25'
        height='20'
        header='SI Not Found'
        footer={null}>
        <div className='messagebox'>
          <div className='messagebox-content'>
            <div>The StockIn file/record no longer exist.</div>
          </div>
          <div className='button-container'>
            <button onClick={onClick} className='pospro-action-btn top-anchor'>Ok</button>
          </div>
        </div>
      </ModalWindow>,
      document.getElementById('modal-form-container')
    )
  }

  const onClickPost = async () => {
    const stock_in = await getStockInByID(app, stockIn._id)

    const showMessageBoxSIAlreadyPosted = async () => {
      const last_modified_by = stock_in.log.last_modified_by.name
      const last_modified = longDateAndTimeString(new Date(stock_in.date_time_modified))
      const onClick = async () => {
        setContent(<StockInListController />)
        ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
      }

      ReactDOM.render (
        <ModalWindow
          id='mw-parent'
          height='25'
          width='30'
          header='SI Posted'
          footer={null}>
          <div className='messagebox'>
            <div className='messagebox-content'>
              <div>This StockIn is already Posted</div>
              <br />
              <div>Posted by {last_modified_by} on {last_modified} </div>
            </div>
            <div className='button-container'>
              <button onClick={onClick} className='pospro-action-btn bottom-anchor'>Ok</button>
            </div>
          </div>
        </ModalWindow>,
        document.getElementById('modal-form-container')
      )
    }

    const showMessageBox = () => {
      const onClick = async (button) => {
        if (button === 'Yes') {
          stockIn.status = 'Posted'
          saveStockIn(app, stockIn)
          .then(updated_si => {
            if (updated_si) {
              setSuccessMessage('Posted successfully! Loading StockIn item, please wait...')
              setNewRecordCount(newRecordCount + 1)
              setTimeout(() => {
                setSuccessMessage('')
                setContent(<StockInItemController stockInItem={updated_si}/>)
              }, 1000)
            }
          })
        }

        ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
      }

      ReactDOM.render (
        <ModalWindow
          id='mw-parent'
          width='35'
          height='35'
          header='Post'
          footer={null}>
          <div className='messagebox'>
            <div className='messagebox-content'>
              <div>You are about to post/add these products to your inventory.</div>
              <br/>
              <div>Are you sure you want to continue?</div>
            </div>
            <div className='button-container'>
              <button onClick={() => { onClick('No') }} className='pospro-action-btn top-anchor'>No</button>
              <button onClick={() => { onClick('Yes') }} className='pospro-action-btn bottom-anchor'>Yes</button>
            </div>
          </div>
        </ModalWindow>,
        document.getElementById('modal-form-container')
      )
    }

    if (stock_in) {
      if (stock_in.status !== 'Posted') showMessageBox()
      else showMessageBoxSIAlreadyPosted()
    }
    else showMessageBoxSINotFound()
  }

  const onClickTransactionsList = async () => setContent(<StockInListController />)

  useEffect(() => {
    setPostOK(
      stockIn.date_received &&
      stockIn.received_by &&
      stockIn.supplier_name &&
      (stockIn.item_details.length > 0)
    )
  }, [stockIn])

  return (
    <ContentFooter>
        <div id="messagebox-container"></div>
        <div id="stock-in-footer-container">
          <span id='new-record-count-container'>
            <span style={{visibility: newRecordCount ? 'visible' : 'hidden'}} id='new-record-count'>
              { newRecordCount ?
                  `${newRecordCount} new record(s) added`
                : null
              }
            </span>
            <span style={{visibility: successMessage ? 'visible' : 'hidden'}} className='notification'>{successMessage}</span>
          </span>
          <div className='translist-button-container'>
            <button className="pospro-action-btn"
              id="trans-list-btn"
              type="button"
              onClick={() => {}}>
              <FontAwesomeIcon icon='list-alt'/>&nbsp;Load from P.O.
            </button>
            <button className="pospro-action-btn"
              id="trans-list-btn"
              type="button"
              onClick={onClickTransactionsList}>
              <FontAwesomeIcon icon='list-alt'/>&nbsp;Transactions List
            </button>
            <button className={ !postOK ? 'pospro-action-btn disabled-button' : 'pospro-action-btn' }
              id="post-item-btn"
              type="button"
              disabled={!postOK}
              onClick={onClickPost}>
              <FontAwesomeIcon icon='save'/>&nbsp;Post
            </button>
          </div>
        </div>
        <StockInFooterStyle />
    </ContentFooter>
  )
}

export default React.memo(StockInFooter)